const HOUSE_CAMERA_ID = 3;
const SENATE_CAMERA_ID = 7;

export { HOUSE_CAMERA_ID, SENATE_CAMERA_ID };
